import React from 'react';
import styled from 'styled-components';
import { useTemplate } from '../../context/TemplateContext';
import PropertyField from './PropertyField';

const TemplateProperties = ({ template }) => {
  const { updateTemplateStyles } = useTemplate();

  const handleStyleChange = (key, value) => {
    updateTemplateStyles({ [key]: value });
  };

  return (
    <PropertiesContainer>
      <PropertyGroup>
        <PropertyGroupTitle>Template Settings</PropertyGroupTitle>
        
        <PropertyField
          label="Background Color"
          type="color"
          value={template.styles.backgroundColor || '#ffffff'}
          onChange={(value) => handleStyleChange('backgroundColor', value)}
        />
        
        <PropertyField
          label="Width"
          type="select"
          value={template.styles.width || '600px'}
          options={[
            { value: '500px', label: '500px' },
            { value: '550px', label: '550px' },
            { value: '600px', label: '600px' },
            { value: '650px', label: '650px' },
            { value: '700px', label: '700px' },
          ]}
          onChange={(value) => handleStyleChange('width', value)}
        />
        
        <PropertyField
          label="Font Family"
          type="select"
          value={template.styles.fontFamily || 'Arial, sans-serif'}
          options={[
            { value: 'Arial, sans-serif', label: 'Arial' },
            { value: 'Helvetica, Arial, sans-serif', label: 'Helvetica' },
            { value: 'Georgia, serif', label: 'Georgia' },
            { value: 'Tahoma, Geneva, sans-serif', label: 'Tahoma' },
            { value: 'Verdana, Geneva, sans-serif', label: 'Verdana' },
            { value: 'Times New Roman, Times, serif', label: 'Times New Roman' },
          ]}
          onChange={(value) => handleStyleChange('fontFamily', value)}
        />
        
        <PropertyField
          label="Text Color"
          type="color"
          value={template.styles.color || '#000000'}
          onChange={(value) => handleStyleChange('color', value)}
        />
      </PropertyGroup>
      
      <PropertyGroup>
        <PropertyGroupTitle>Template Preview</PropertyGroupTitle>
        <TemplatePreview>
          <PreviewBox style={{
            backgroundColor: template.styles.backgroundColor,
            fontFamily: template.styles.fontFamily,
            color: template.styles.color
          }}>
            <PreviewText>Template Preview</PreviewText>
            <PreviewSubtext>Width: {template.styles.width}</PreviewSubtext>
          </PreviewBox>
        </TemplatePreview>
      </PropertyGroup>
      
      <PropertyGroup>
        <PropertyGroupTitle>Help & Tips</PropertyGroupTitle>
        <TipsList>
          <TipItem>
            <i className="fas fa-info-circle"></i>
            <span>Drag elements from the sidebar to add them to your template</span>
          </TipItem>
          <TipItem>
            <i className="fas fa-info-circle"></i>
            <span>Click on elements to edit their properties</span>
          </TipItem>
          <TipItem>
            <i className="fas fa-info-circle"></i>
            <span>Use the Export button to copy your HTML code</span>
          </TipItem>
        </TipsList>
      </PropertyGroup>
    </PropertiesContainer>
  );
};

const PropertiesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const PropertyGroup = styled.div`
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 15px;
`;

const PropertyGroupTitle = styled.h3`
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin: 0 0 15px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
`;

const TemplatePreview = styled.div`
  margin-top: 10px;
`;

const PreviewBox = styled.div`
  padding: 15px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  text-align: center;
`;

const PreviewText = styled.div`
  font-weight: bold;
  margin-bottom: 5px;
`;

const PreviewSubtext = styled.div`
  font-size: 12px;
  opacity: 0.7;
`;

const TipsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const TipItem = styled.li`
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
  
  i {
    color: #5876ff;
    margin-right: 10px;
    margin-top: 2px;
  }
  
  span {
    font-size: 13px;
  }
`;

export default TemplateProperties;
